<template>
    <div class="login-bg">
        <div class="login">
            <img @click="registHide" class="login-close" :src="close_img"/>
            <div class="login-title">账号注册</div>
            <p class="login-regist">已有帐号?现在去<span @click="loginShow">登录</span></p>
            <el-form :model="ruleForm" :rules="rules">
                <el-form-item class="input" prop="mobile">
                    <el-input type="text" v-model="ruleForm.mobile" placeholder="手机号"></el-input>
                </el-form-item>
                <el-form-item class="input" prop="code">
                    <el-input class="input-with-select" type="text" v-model="ruleForm.code" placeholder="短信验证码"><span slot="append" class="code" @click="getCode">{{massage}}</span></el-input>
                </el-form-item>
                <el-form-item class="input" prop="email">
                    <el-input type="text" v-model="ruleForm.email" placeholder="邮箱"></el-input>
                </el-form-item>
                <el-form-item class="input" prop="password">
                    <el-input type="password" v-model="ruleForm.password" placeholder="设置密码"></el-input>
                </el-form-item>
                <el-form-item class="input" prop="username">      
                    <el-input type="text" v-model="ruleForm.username" placeholder="设置用户名"></el-input>
                </el-form-item>    
                <el-button class="button" @click="regist" v-bind:disabled="!checked" :loading="buttonLoading">立即注册</el-button>
            </el-form>
            <div class="wx-login"><span class="login-line left"></span>微信登录<span class="login-line right"></span></div>
            <img class="wx-logo"  @click="wxloginShow" :src="weixin_img" />
            <div class="choose-bg"></div>
            <div class="choose"><el-checkbox class="checkbox" v-model="checked"></el-checkbox><a href="">勾选即代表您同意接受《某某某政策》</a></div>
        </div>
    </div>
</template>

<script>
import close_img from '@assets/image/icon/close.png'
import weixin_img from '@assets/image/icon/weixin.png'

export default {
    data(){
        return {
            close_img,
            weixin_img,
            buttonLoading:false,
            ruleForm:{
                mobile:'',
                code:'',
                password:'',
                username:'',
                email:''
            },
            checked:false,
            count: '',
            timer: null,
            massage:'获取验证码',
            rules:{
                mobile:[
                    { required: true, message: '请输入您的电话号码', trigger: 'blur'},
                ],
                code:[
                    { required: true, message: '请输入验证码', trigger: 'blur'},
                ],
                password:[
                    { required: true, message: '请输入您的密码', trigger: 'blur'},
                ],
                username:[
                    { required: true, message: '请输入您的用户名', trigger: 'blur'},
                ],
                email:[
                    { required: true, message: '请输入您的邮箱', trigger: 'blur'},
                ],
            }
        }
    },
    mounted(){

    },
    methods:{
        registHide(){
            this.$parent.registHide()
        },
        registShow(){
            this.$parent.registShow()
        },
        loginShow(){
            this.$parent.registHide()
            this.$parent.loginShow()
        },
        wxloginShow(){
            this.$parent.wxloginShow()
            this.$parent.registHide()
        },
        goIndex(){
            this.$router.push('/')
        },
        getCode() {
            const num = 60;
            if(!this.ruleForm.mobile){
                this.$message({
                    message: '请先填写手机号',
                    type: 'warning'
                });
                return;
            }
            if (!this.timer) {
                this.sendCode()
                this.count = num;
                this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= num) {
                    this.massage = this.count-- +'秒后再次发送';
                } else {
                    clearInterval(this.timer);
                    this.timer = null;
                     this.massage = '获取验证码';
                }
                }, 1000);
            }
        },
        sendCode(){
            var that = this
            this.axios.get(this.url+'/api/sms/send',{params:{mobile:that.ruleForm.mobile}}).then(function(response){
                if(response.data.code == 1){
                    that.$message({
                        message: '验证码已成功发送',
                        type: 'success'
                    });
                }else{
                    that.$message({
                        message: response.data.msg,
                        type: 'warning'
                    });
                }
            }).catch(function() {
            });
        },
        regist(){
            var that = this
            this.buttonLoading = true
            console.log(this.ruleForm)
            this.axios.get(this.url+'/api/user/register',{params:this.ruleForm}).then(function(response){
                if(response.data.code == 1){
                    that.$message({
                        message: "注册成功",
                        type: 'success'
                    });
                    that.buttonLoading = false
                    that.registHide()
                    that.loginHide()
                }else{
                    that.$message({
                        message: response.data.msg,
                        type: 'warning'
                    });
                    that.buttonLoading = false
                }
            }).catch(function() {
            });
        }
    }
}
</script>
<style lang="scss" scoped>
.login-bg{
    width: 100%;
    height: 100vh;
    top:0;
    position: fixed;
    background: rgba($color: #000000, $alpha: 0.6);
    z-index: 100;
}
.login{
    width: 35rem;
    height: auto;
    background: #fff;
    border-radius: 4px;
    top:50%;
    bottom: 50%;
    right: 50%;
    left: 50%;
    color: $color;
    padding:3rem 6rem 0;
    margin-top:-18rem;
    margin-left:-17rem;
    position: relative;
}
.login-close{
    position: absolute;
    top:0.5rem;
    right: 0.5rem;
    cursor: pointer;
}
.login-title{
    font-size: 1.5rem;
}
.login-regist{
    text-align: right;
    font-size: 0.8rem;
    line-height: 1.6rem;
    cursor: pointer;
    span{
        color: #a22915;
    }
}
.login-line{
    width: 7.5rem;
    display:inline-block;
    margin-bottom: 0.3rem;
	border: solid 1px #c0c0c0;
}
.left{
    margin-right: 1rem;
}
.right{
    margin-left: 1rem;
}
.input{
    margin-bottom: 1rem;
}
.code{
    color:#a22915;
    cursor: pointer;
}
.button{
    width: 100%;
    background: $color;
    color: #fff;
    margin-bottom: 1.2rem;
}
.wx-login{
    width: 100%;
    text-align: center;
    color: #c1c1c1;
    font-size: 1rem;
}
.wx-logo{
    display: block;
    width: 2.3rem;
    height: 2.3rem;
    margin:1rem auto;
    box-sizing: border-box;
    cursor: pointer;
}
.choose{
    width: 100%;
    height: 2.5rem;
    position: absolute;
    bottom: 0;
    left: 0;
    font-size: 0.8rem;
    color: #a6a6a6;
    line-height:2.5rem;
    text-align: center;
    background: #f6f6f6;
}
.choose-bg{
    width: 100%;
    height: 2.5rem;
}
.checkbox{
    margin-right: 0.5rem;
}
</style>